// Build-time override via REACT_APP_API_URL (set in .env.development for local,
// or supplied by the staging/prod build commands). Defaults to the prod URL so
// existing production builds keep producing identical output without any extra
// configuration.
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.englishteacher.co.uk';

export default API_URL;
